import { render, staticRenderFns } from "./GeneralInformations.vue?vue&type=template&id=48bf0b0a&"
import script from "./GeneralInformations.vue?vue&type=script&lang=js&"
export * from "./GeneralInformations.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInformations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports